import store from '@/store'

export default [
  {
    path: '/scholarships',
    name: 'scholarship',
    meta: { requiresAuth: true },
    component: () => import('@/pages/scholarship/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('scholarship/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/scholarships/:acps_id/:grade_definition_id',
    name: 'scholarship-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/scholarship/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('scholarship/dataBeforeCreate')
      await store.dispatch('scholarship/find', to.params)
      next()
    }
  }
]
